import { AttachmentType } from '@/constants/documents';
import { IconFee, IconHouseholdUtilities, IconProfileAlternative, IllustrationEnterName, IllustrationInTransit, IllustrationPurchaseDetails, IllustrationThumbsUp, } from '@klarna/bubble-ui';
export const tPrefix = 'products-fe.containers.documents';
export const ICON_MAP = {
    [AttachmentType.APPROVAL]: IllustrationThumbsUp,
    [AttachmentType.CERTIFIED_ID]: IconProfileAlternative,
    [AttachmentType.CONTRACT]: IllustrationPurchaseDetails,
    [AttachmentType.CORRECTION_NOTE]: IllustrationPurchaseDetails,
    [AttachmentType.COUNTERSIGNED_CONTRACT]: IllustrationPurchaseDetails,
    [AttachmentType.ID_DOCUMENT]: IconProfileAlternative,
    [AttachmentType.LICENSE]: IllustrationInTransit,
    [AttachmentType.PROOF_OF_ADDRESS]: IconHouseholdUtilities,
    [AttachmentType.SPECIAL_AGREEMENT]: IllustrationEnterName,
    [AttachmentType.SUPPORTING_DOCUMENT]: IllustrationPurchaseDetails,
    [AttachmentType.TAX_OFFICE_REGISTRATION]: IconFee,
};
export const MAX_NUMBER_OF_FILES = 20;
export const MAX_FILE_SIZE_IN_MB = 10;
export const ACCEPTED_FORMATS = ['.JPG', '.JPEG', '.PDF', '.PNG'];
export const ERROR_CODES = {
    MAX_NUM_FILES_EXCEEDED: 'max_num_files_exceeded',
    INVALID_FILE_FORMAT: 'invalid_file_format',
    DUPLICATE_FILE_NAME: 'duplicate_file_name',
};
